import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClickCatcherDirective } from './click-catcher/click-catcher.directive';
import { DialogModule } from '../components/dialog/dialog.module';
import { IsObjectDirective } from './is-object/is-object.directive';
import { CustomTooltipDirective } from './tooltip/custom-tooltip.directive';
import { LazyLoadingListDirective } from './lazy-loading-list/lazy-loading-list.directive';
import { InsightPopUpBinderDirective } from './popup-binder/popup-binder.directive';
import { AskViaDirective } from '@cpd-app/shared-module/directives/ask-via/ask-via.directive';

@NgModule({
  imports: [CommonModule, DialogModule],
  declarations: [
    ClickCatcherDirective,
    IsObjectDirective,
    CustomTooltipDirective,
    LazyLoadingListDirective,
    AskViaDirective,
    InsightPopUpBinderDirective
  ],
  exports: [
    ClickCatcherDirective,
    IsObjectDirective,
    CustomTooltipDirective,
    LazyLoadingListDirective,
    AskViaDirective,
    InsightPopUpBinderDirective
  ]
})
export class DirectivesModule {}
